var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCartSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 18.125C7.94036 18.125 8.5 17.5654 8.5 16.875C8.5 16.1846 7.94036 15.625 7.25 15.625C6.55964 15.625 6 16.1846 6 16.875C6 17.5654 6.55964 18.125 7.25 18.125Z",
    fill: "#525E9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 18.125C16.0654 18.125 16.625 17.5654 16.625 16.875C16.625 16.1846 16.0654 15.625 15.375 15.625C14.6846 15.625 14.125 16.1846 14.125 16.875C14.125 17.5654 14.6846 18.125 15.375 18.125Z",
    fill: "#525E9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30357 5.625H18.3214L16.259 12.8434C16.1844 13.1046 16.0267 13.3344 15.8099 13.4979C15.593 13.6615 15.3288 13.75 15.0571 13.75H7.56788C7.29624 13.75 7.03199 13.6615 6.81513 13.4979C6.59827 13.3344 6.4406 13.1046 6.36597 12.8434L3.54023 2.9533C3.50292 2.82271 3.42408 2.70782 3.31565 2.62603C3.20722 2.54424 3.07509 2.5 2.93928 2.5H1.625",
    fill: "#525E9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30357 5.625H18.3214L16.259 12.8434C16.1844 13.1046 16.0267 13.3344 15.8099 13.4979C15.593 13.6615 15.3288 13.75 15.0571 13.75H7.56788C7.29624 13.75 7.03199 13.6615 6.81513 13.4979C6.59827 13.3344 6.4406 13.1046 6.36597 12.8434L3.54023 2.9533C3.50292 2.82271 3.42408 2.70782 3.31565 2.62603C3.20722 2.54424 3.07509 2.5 2.93928 2.5H1.625",
    stroke: "#525E9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartSimple);
export default __webpack_public_path__ + "static/media/ShoppingCartSimple.f832cffc2abd695709a16b34bd41eb85.svg";
export { ForwardRef as ReactComponent };